module.exports = __webpack_public_path__ + "img/bedrooms-green.8e7a1f1b.svg";